<div nxLayout="grid">
  <!-- Filters + Upload Button -->
  <div nxRow nxRowJustify="start,start,around">
    <div nxCol="12">
      <div nxLayout="grid" class="nx-margin-top-s">
        <div nxRow>
          <div nxCol="2">
            <nx-formfield>
              <input nxInput placeholder="Enter Keyword" [(ngModel)]="searchTerm" type="search" />
              <span nxFormfieldPrefix><nx-icon name="search" size="s"></nx-icon></span>
              <span nxFormfieldSuffix *ngIf="searchTerm" aria-hidden="true" (click)="searchTerm=''; getInvoiceList()">
                <nx-icon name="close" size="s"></nx-icon>
              </span>
            </nx-formfield>
          </div>

          <div nxCol="2">
            <nx-formfield nxLabel="Start Date">
              <input nxDatefield nxInput [nxDatepicker]="startDatepicker" [(ngModel)]="startDate" />
              <nx-datepicker-toggle [for]="startDatepicker" nxFormfieldSuffix></nx-datepicker-toggle>
              <nx-datepicker #startDatepicker></nx-datepicker>
            </nx-formfield>
          </div>

          <div nxCol="2">
            <nx-formfield nxLabel="End Date">
              <input nxDatefield nxInput [nxDatepicker]="endDatepicker" [(ngModel)]="endDate" />
              <nx-datepicker-toggle [for]="endDatepicker" nxFormfieldSuffix></nx-datepicker-toggle>
              <nx-datepicker #endDatepicker></nx-datepicker>
            </nx-formfield>
          </div>

          <div nxCol="6" class="nx-margin-top-2xs" style="display:flex; gap:8px; align-items:flex-start; flex-wrap:wrap;">
            <button nxButton="primary small-medium" type="button" (click)="pageNumber=1; getInvoiceList()">Search</button>
            <button nxButton="secondary small-medium" type="button" (click)="exportToExcel()">
              <nx-icon name="file-spreadsheet" class="nx-margin-right-2xs"></nx-icon>Export
            </button>
            <button nxButton="secondary small-medium" type="button" (click)="openUploadModal()">
              <nx-icon name="plus" class="nx-margin-right-2xs"></nx-icon>Upload PFU Invoice
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div nxRow nxRowJustify="start,start,around">
    <div nxCol="12">
      <table nxTable zebra condensed nxSort (sortChange)="sortTable($event)">
        <thead>
          <tr nxTableRow>
            <th nxHeaderCell nxSortHeaderCell="referenceNo">Reference No.</th>
            <th nxHeaderCell nxSortHeaderCell="dealerName">Dealer</th>
            <th nxHeaderCell nxSortHeaderCell="invoiceMonth">Invoice Period</th>
            <th nxHeaderCell nxSortHeaderCell="uploadedOn">Uploaded On</th>
            <th nxHeaderCell>AWP Comments</th>
            <th nxHeaderCell>Dealer Comments</th>
            <th nxHeaderCell nxSortHeaderCell="status">Status</th>
            <th nxHeaderCell>Actions</th>
          </tr>
        </thead>
        <tbody style="text-align: center">
          <tr nxTableRow *ngFor="let item of invoiceList">
            <td nxTableCell>{{ item.referenceNo }}</td>
            <td nxTableCell>{{ item.dealerName }}</td>
            <td nxTableCell>{{ months[item.invoiceMonth - 1] }} {{ item.invoiceYear }}</td>
            <td nxTableCell>{{ item.submittedOn | date:'dd/MM/yyyy' }}</td>
            <td nxTableCell class="comment-cell">{{ item.comments }}</td>
            <td nxTableCell class="comment-cell">
              <span *ngIf="item.disputeComment; else noDispute">{{ item.disputeComment }}</span>
              <ng-template #noDispute><span class="no-comment">—</span></ng-template>
            </td>
            <td nxTableCell>
              <nx-badge [type]="badgeType(item.status)">{{ item.status }}</nx-badge>
            </td>
            <td nxTableCell>
              <nx-context-menu #menu="nxContextMenu">
                <ng-template nxContextMenuContent>
                  <button nxContextMenuItem type="button" (click)="downloadInvoice(item.id, item.referenceNo)">
                    <nx-icon name="download" class="nx-margin-right-2xs"></nx-icon>Download Invoice
                  </button>
                  <button nxContextMenuItem type="button" (click)="openDisputeModal(item)">
                    <nx-icon name="edit" class="nx-margin-right-2xs"></nx-icon>
                    Dispute Comments
                  </button>
                </ng-template>
              </nx-context-menu>
              <button nxIconButton="tertiary medium" type="button" [nxContextMenuTriggerFor]="menu"
                aria-label="Open menu" nxTooltip="Actions" nxTooltipPosition="top">
                <nx-icon aria-hidden="true" name="ellipsis-h"></nx-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- No Records -->
      <div *ngIf="count === 0" class="nx-margin-top-2xl">
        <div nxRow nxRowJustify="center">
          <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold">No Records found !!!</h3>
        </div>
      </div>

      <!-- Pagination -->
      <div nxRow style="float: right" *ngIf="count > 0">
        <div nxCol="12">
          <nx-pagination
            [nxCount]="count"
            [nxPage]="pageNumber"
            [nxPerPage]="pageSize"
            nxType="advanced"
            (nxGoPrev)="prevPage()"
            (nxGoNext)="nextPage()"
            (nxGoPage)="goToPage($event)"
          ></nx-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ===================== Upload PFU Invoice Modal ===================== -->
<nx-modal [nxHideOnClickOutside]="false" [nxHideOnEsc]="false" *ngIf="uploadModalOpen" [nxShowCloseIcon]="false">
  <div nxLayout="grid">
    <div nxRow>
      <div nxCol="12">
        <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold">Upload PFU Invoice</h3>
        <p nxCopytext="small" class="nx-margin-bottom-s">
          Upload the PFU invoice PDF for the selected dealership. Add AWP admin comments describing the invoice details.
        </p>
      </div>
    </div>

    <!-- File Upload -->
    <div nxRow>
      <div nxCol="12">
        <nx-label class="nx-margin-bottom-2xs">Invoice PDF <span class="required-star">*</span></nx-label>
        <app-upload
          (onUploadFinished)="onFileUploaded($event)"
          [acceptedfiles]="acceptedTypes"
          [uploadPath]="uploadPath"
        ></app-upload>
        <nx-message *ngIf="!uploadedFilePath" context="info" class="nx-margin-top-2xs">
          Upload the PDF first, then complete the form below and click Submit.
        </nx-message>
      </div>
    </div>

    <form [formGroup]="uploadForm">
      <!-- Dealer -->
      <div nxRow class="nx-margin-top-s">
        <div nxCol="12">
          <nx-formfield nxLabel="Dealer">
         <nx-dropdown #selectedClient formControlName="dealerId" placeholder="Select Dealer">
          <nx-dropdown-item *ngFor="let item of dealerList" [nxValue]="item.workshopId">
            {{ item.workshopName }}
          </nx-dropdown-item>
        </nx-dropdown>
            <nx-error *ngIf="uploadForm.get('dealerId').hasError('required') && uploadForm.get('dealerId').touched">
              Please select a dealer.
            </nx-error>
          </nx-formfield>
        </div>
      </div>

      <!-- Month & Year -->
      <div nxRow>
        <div nxCol="6">
          <nx-formfield nxLabel="Invoice Month">
            <nx-dropdown formControlName="invoiceMonth" placeholder="Select Month">
              <nx-dropdown-item *ngFor="let month of months" [nxValue]="month">{{ month }}</nx-dropdown-item>
            </nx-dropdown>
            <nx-error *ngIf="uploadForm.get('invoiceMonth').hasError('required') && uploadForm.get('invoiceMonth').touched">
              Please select the invoice month.
            </nx-error>
          </nx-formfield>
        </div>

        <div nxCol="6">
          <nx-formfield nxLabel="Invoice Year">
            <nx-dropdown formControlName="invoiceYear" placeholder="Select Year">
              <nx-dropdown-item *ngFor="let year of years" [nxValue]="year">{{ year }}</nx-dropdown-item>
            </nx-dropdown>
            <nx-error *ngIf="uploadForm.get('invoiceYear').hasError('required') && uploadForm.get('invoiceYear').touched">
              Please select the invoice year.
            </nx-error>
          </nx-formfield>
        </div>
      </div>

      <!-- AWP Admin Comments -->
      <div nxRow>
        <div nxCol="12">
          <nx-formfield nxLabel="AWP Admin Comments">
            <textarea nxInput formControlName="comments" rows="4"
              placeholder="Describe the invoice — billing period, amount, policy count, etc."></textarea>
            <nx-error *ngIf="uploadForm.get('comments').hasError('required') && uploadForm.get('comments').touched">
              Please add comments describing the invoice.
            </nx-error>
            <nx-error *ngIf="uploadForm.get('comments').hasError('maxlength')">
              Comments cannot exceed 1000 characters.
            </nx-error>
          </nx-formfield>
        </div>
      </div>
    </form>

    <!-- Actions -->
    <div nxRow class="nx-margin-top-s">
      <div nxCol="6">
        <button nxButton="block primary" type="button"
          [disabled]="submitting || !uploadedFilePath"
          (click)="submitInvoice()">
          {{ submitting ? 'Submitting...' : 'Submit Invoice' }}
        </button>
      </div>
      <div nxCol="6">
        <button nxButton="block secondary" type="button" (click)="closeUploadModal()">Cancel</button>
      </div>
    </div>
  </div>
</nx-modal>

<!-- ===================== Dealer Dispute Review Modal ===================== -->
<nx-modal [nxHideOnClickOutside]="false" [nxHideOnEsc]="false" *ngIf="disputeModalOpen" [nxShowCloseIcon]="false">
  <div nxLayout="grid" *ngIf="selectedInvoice">
    <div nxRow>
      <div nxCol="12">
        <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold">Review Dealer Dispute</h3>
        <p nxCopytext="small" class="nx-margin-bottom-2xs">
          Reference: <strong>{{ selectedInvoice.referenceNo }}</strong> &mdash;
          {{ months[selectedInvoice.invoiceMonth - 1] }} {{ selectedInvoice.invoiceYear }}
        </p>
        <p nxCopytext="small" class="nx-margin-bottom-s">
          Dealer: <strong>{{ selectedInvoice.dealerName }}</strong>
        </p>
      </div>
    </div>

    <!-- AWP Admin Comments (read-only) -->
    <div nxRow>
      <div nxCol="12">
        <nx-label class="nx-margin-bottom-2xs">AWP Admin Comments</nx-label>
        <div class="readonly-comment nx-margin-bottom-s">{{ selectedInvoice.comments || '—' }}</div>
      </div>
    </div>

    <!-- Dealer Dispute Comment (read-only) -->
    <div nxRow>
      <div nxCol="12">
        <nx-label class="nx-margin-bottom-2xs">Dealer Dispute Comment</nx-label>
        <div class="readonly-comment nx-margin-bottom-s">{{ selectedInvoice.disputeComment || '—' }}</div>
      </div>
    </div>

    <!-- AWP Review Comment -->
    <ng-container *ngIf="selectedInvoice.status === 'Approved'; else reviewForm">
      <div nxRow>
        <div nxCol="12">
          <nx-label class="nx-margin-bottom-2xs">AWP Review Comment</nx-label>
          <div class="readonly-comment nx-margin-bottom-s">{{ selectedInvoice.adminComments || '—' }}</div>
        </div>
      </div>
      <div nxRow class="nx-margin-top-s">
        <div nxCol="12">
          <button nxButton="block secondary" type="button" (click)="closeDisputeModal()">Close</button>
        </div>
      </div>
    </ng-container>

    <ng-template #reviewForm>
      <form [formGroup]="disputeForm">
        <div nxRow>
          <div nxCol="12">
            <nx-formfield nxLabel="AWP Review Comment">
              <textarea nxInput formControlName="adminComments" rows="4"
                placeholder="Add your review comment — reason for approval or rejection..."></textarea>
              <nx-error nxFormfieldError="required">Please enter a review comment.</nx-error>
              <nx-error nxFormfieldError="maxlength">Comment cannot exceed 1000 characters.</nx-error>
            </nx-formfield>
          </div>
        </div>
      </form>
      <div nxRow class="nx-margin-top-s">
        <div nxCol="4">
          <button nxButton="block primary" type="button"
            [disabled]="disputeInProgress"
            (click)="submitDisputeReview('Approved')">
            {{ disputeInProgress && disputeDecision === 'Approved' ? 'Saving...' : 'Approve' }}
          </button>
        </div>
        <div nxCol="4">
          <button nxButton="block negative" type="button"
            [disabled]="disputeInProgress"
            (click)="submitDisputeReview('Rejected')">
            {{ disputeInProgress && disputeDecision === 'Rejected' ? 'Saving...' : 'Reject' }}
          </button>
        </div>
        <div nxCol="4">
          <button nxButton="block secondary" type="button" (click)="closeDisputeModal()">Cancel</button>
        </div>
      </div>
    </ng-template>
  </div>
</nx-modal>
